import { Component } from '@angular/core';
import { IParticipant } from '@interfaces/interfaces';
import { NzTableData, NzTablePaginationPosition, NzTableSize } from 'ng-zorro-antd/table/src/table.types';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';

@Component({
	selector: 'app-table-showcase',
	templateUrl: './table-showcase.component.html'
})
export class TableShowcaseComponent {
	public participants: Array<IParticipant> = [{
		id: '123',
		data: {
			personal: {
				firstName: 'Freddie',
				lastName: 'Mercury',
				birthday: '1946-09-05',
			},
			address: {
				address: '12 Stafford Terrace',
				city: 'London',
				zipCode: 'W8 7BH',
				country: 'UK',
			},
			projects: {

			}
		},

	},
	{
		id: '456',
		data: {
			personal: {
				firstName: 'Michael',
				lastName: 'Jackson',
				birthday: '1958-08-29',
			},
			address: {
				address: '5225 Figueroa Mountain Road',
				city: ' Los Olivos',
				zipCode: '93441',
				country: 'US',
			},
			projects: {

			}
		},

	}];

	public checked = false;
	public indeterminate = false;
	public setOfCheckedId = new Set<string>();
	public visibleParticipants = this.participants;

	public simple = false;
	public loading = false;
	public pagination = true;
	public position: NzTablePaginationPosition = 'bottom';
	public header = true;
	public title = false;
	public expandable = true;
	public checkbox = false;
	public allChecked = false;
	public footer = false;
	public bordered = false;
	public sizeChanger = false;
	public size: NzTableSize = 'small';
	public privacyMode = false;
	public hasProject = false;

	public uidFilterValue = '';
	public firstNameFilterValue = '';
	public lastNameFilterValue = '';
	public birthdayFilterValue = '';

	public uidFilterVisible = false;
	public firstNameFilterVisible = false;
	public lastNameFilterVisible = false;
	public birthdayFilterVisible = false;

	public userAddButton1: SplitButtonElement = {
		title: 'actions.add',
		type: 'primary',
		icon: 'plus',
	};

	public userAddButton2: SplitButtonElement = {
		title: 'actions.add',
		type: 'default',
		icon: 'plus',
	};

	compareUid(a: NzTableData, b: NzTableData): number {
		return a.id.localeCompare(b.id);
	}

	compareFirstname(a: NzTableData, b: NzTableData): number {
		return a.data.personal.firstName.localeCompare(b.data.personal.firstName);
	}

	compareLastname(a: NzTableData, b: NzTableData): number {
		return a.data.personal.lastName.localeCompare(b.data.personal.lastName);
	}

	compareBirthday(a: NzTableData, b: NzTableData): number {
		return a.data.personal.birthday.localeCompare(b.data.personal.birthday);
	}

	filterUid(): void {
		this.resetFilters('uid');
		this.visibleParticipants = this.participants.filter((item: IParticipant) =>
			item.id.toLowerCase().includes(this.uidFilterValue.toLowerCase()));
	}

	filterFirstName(): void {
		this.resetFilters('firstName');
		this.visibleParticipants = this.participants.filter((item: IParticipant) =>
			item.data.personal.firstName.toLowerCase().includes(this.firstNameFilterValue.toLowerCase()));
	}

	filterLastName(): void {
		this.resetFilters('lastName');
		this.visibleParticipants = this.participants.filter((item: IParticipant) =>
			item.data.personal.lastName.toLowerCase().includes(this.lastNameFilterValue.toLowerCase()));
	}

	filterBirthday(): void {
		this.resetFilters('birthday');
		this.visibleParticipants = this.participants.filter((item: IParticipant) =>
			item.data.personal.birthday.toLowerCase().includes(this.birthdayFilterValue.toLowerCase()));
	}

	private resetFilters(filterName: string): void {
		if (filterName !== 'uid') {
			this.uidFilterValue = '';
		}
		if (filterName !== 'firstName') {
			this.firstNameFilterValue = '';
		}
		if (filterName !== 'lastName') {
			this.lastNameFilterValue = '';
		}
		if (filterName !== 'birthday') {
			this.birthdayFilterValue = '';
		}
	}

	onAllChecked(checked: boolean): void {
		this.visibleParticipants.forEach(({ id }) => this.updateCheckedSet(id, checked));
		this.refreshCheckedStatus();
	}

	onItemChecked(id: string, checked: boolean): void {
		this.updateCheckedSet(id, checked);
		this.refreshCheckedStatus();
	}

	refreshCheckedStatus(): void {
		const listOfEnabledData = this.visibleParticipants;
		this.checked = listOfEnabledData.every(({ id }) => this.setOfCheckedId.has(id));
		this.indeterminate = listOfEnabledData.some(({ id }) => this.setOfCheckedId.has(id)) && !this.checked;
	}

	updateCheckedSet(id: string, checked: boolean): void {
		if (checked) {
			this.setOfCheckedId.add(id);
		} else {
			this.setOfCheckedId.delete(id);
		}
	}
}
